import React from 'react';
import { StylesConsumer, StylesProvider } from '../StylesContext';
import { createWixSDKAdapter } from '../../utils/sdkAdapter/wixSDKAdapter';
export var TPASettingsProviderForModal = function (_a) {
    var Wix = _a.Wix, children = _a.children, styleParamsPerBreakpointMode = _a.styleParamsPerBreakpointMode;
    var SDKAdapter = createWixSDKAdapter(Wix);
    if (!Wix) {
        return null;
    }
    return (React.createElement(StylesProvider, { SDKAdapter: SDKAdapter, styleParamsPerBreakpointMode: styleParamsPerBreakpointMode },
        React.createElement(StylesConsumer, null, function (styles) { return styles.ready && children; })));
};
//# sourceMappingURL=TPASettingsProviderForModal.js.map